import { useCallback, useEffect } from "react";

import { useMonitoringStore } from "../@modules/monitor/monitoringStore";

export const useIsFullscreen = () => {
  const isFullscreen = useMonitoringStore((s) => s.isFullscreen);
  const setIsFullscreen = useMonitoringStore((s) => s.setIsFullscreen);

  const handleChange = useCallback(() => {
    setIsFullscreen(!!document.fullscreenElement);
  }, [setIsFullscreen]);

  useEffect(() => {
    addEventListener("fullscreenchange", handleChange);

    return () => {
      removeEventListener("fullscreenchange", handleChange);
    };
  });

  return isFullscreen;
};
